import { createEvent, createStore } from 'effector';

export const openNotificationsPanel = createEvent('open notification panel');
export const closeNotificationsPanel = createEvent('close notification panel');

export const $isNotificationsOpened = createStore(false)
  .on(openNotificationsPanel, () => true)
  .on(closeNotificationsPanel, () => false);
